import React,{useState,useEffect} from 'react';
// import PropTypes from 'prop-types';

// Composants Material UI
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';


import ToggleButton      from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

// Composants génériques
import S_App      from '../../services/S_App';
import S_Date     from '../../services/S_Date';

// Composants propres
import S_Stocks         from '../services/S_Stocks';
import {I_Stock}        from '../services/I_Stock';

// Styles
// import './DialogEditPump.scss';

type DialogEditStockProps = {
  isDialogOpened: boolean;
  closeDialog: any;            // function close

  onClickDelete: any;
  onClickValidate: any;
  item: I_Stock;
}

function DialogEditStock(props:DialogEditStockProps) {

  // props
  let {isDialogOpened,closeDialog,onClickDelete,onClickValidate,item} = props;

  let dayMillis_pump = item ? item.datePump : undefined;
  let dayMillis = item ? item.date : undefined;
  let dayUsedMillis = item ? item.dateUsed : undefined;

  // state
  const [datePumpForMaterial, setDatePumpForMaterial] = useState(S_Date.formatDateForMaterial(dayMillis_pump));
  const [dateForMaterial, setDateForMaterial] = useState(S_Date.formatDateForMaterial(dayMillis));
  const [ml, setMl] = useState(item ? item.ml : 40);
  const [where, setWhere] = useState(item ? item.where : 'Frigo');
  const [used, setUsed] = useState(item ? item.used : undefined);
  const [dateUsedForMaterial, setDateUsedForMaterial] = useState(S_Date.formatDateForMaterial(dayUsedMillis));
  const [category1, setCategory1] = useState(undefined);

  // chargement des donnees
  useEffect(() => {
    setDateForMaterial(S_Date.formatDateForMaterial(dayMillis));
    setMl(item ? item.ml : 40);
    setWhere(item ? item.where : 'Frigo');
    setUsed(item ? item.used : undefined);
    setDateUsedForMaterial(S_Date.formatDateForMaterial(dayUsedMillis));
    setCategory1(item ? item.category1 : undefined);
  }, []);

  function changeDatePump(value){
    setDatePumpForMaterial(value);
  }
  function changeDate(value){
    setDateForMaterial(value);
  }
  function changeMl(value){
    setMl(value);
  }
  function changeWhere(value){
    setWhere(value);
  }
  function changeUsed(value){
    setUsed(value);
  }
  function changeDateUsed(value){
    setDateUsedForMaterial(value);
  }
  function changeCategory1(value){
    if(value === '') value = undefined;
    setCategory1(value);
  }

  function close(){
    closeDialog();
    setDatePumpForMaterial(S_Date.formatDateForMaterial(dayMillis_pump));
    setDateForMaterial(S_Date.formatDateForMaterial(dayMillis));
    setMl(item ? item.ml : 40);
    setWhere(item ? item.where : 'Frigo');
    setDateUsedForMaterial(S_Date.formatDateForMaterial(dayUsedMillis));
    setCategory1(undefined);
  }
  function validate(){
    onClickValidate(daySelectedInMillis_pump,daySelectedInMillis,ml,where,used,dayUsedSelectedInMillis,category1);
    setDatePumpForMaterial(S_Date.formatDateForMaterial(dayMillis_pump));
    setDateForMaterial(S_Date.formatDateForMaterial(dayMillis));
    setMl(item ? item.ml : 40);
    setWhere(item ? item.where : 'Frigo');
    setDateUsedForMaterial(S_Date.formatDateForMaterial(dayUsedMillis));
    setCategory1(undefined);
  }

  // on transforme la date "material" en date in millis, et on la cale à 1h.
  let daySelectedInMillis_pump = S_Date.getDayReference(S_Date.formatDateInMillis(datePumpForMaterial));
  let daySelectedInMillis = S_Date.getDayReference(S_Date.formatDateInMillis(dateForMaterial));
  let dayUsedSelectedInMillis = S_Date.getDayReference(S_Date.formatDateInMillis(dateUsedForMaterial));

  // suggestions de category1
  let categories1Map = S_App.groupByCategory1(S_Stocks.stocks);
  let categories1 = !!categories1Map ? Object.keys(categories1Map) : [];

  return (
    <>
    <Dialog
      open={isDialogOpened}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Modifier un élément de stock</DialogTitle>
      <DialogContent>
        
        <TextField id="quantity" label={'Quantité stockée (ml)'} type="number" InputProps={{inputProps: { min: 0 }}} fullWidth size="small"
          value={ml}
          onChange={(e) => changeMl(e.target.value)} />

        <TextField label={'Date de pompage'} type="date" size="small" InputLabelProps={{ shrink: true }} fullWidth 
          value={S_Date.formatDateForMaterial(datePumpForMaterial)} 
          onChange={(e) => changeDatePump(e.target.value)} />
        <TextField label={where == 'Congel' ? 'Date de congélation' : 'Date de stockage'} type="date" size="small" InputLabelProps={{ shrink: true }} fullWidth 
          value={S_Date.formatDateForMaterial(dateForMaterial)} 
          onChange={(e) => changeDate(e.target.value)} />
        <div className="text-left">
          <div>Lieu de stockage</div>
          <ToggleButtonGroup value={where} exclusive onChange={(event, newAlignment) => changeWhere(newAlignment)} aria-label="Lieu de stockage">
            <ToggleButton value="Tempéré" aria-label="Tempéré">
              Temp.
            </ToggleButton>
            <ToggleButton value="Frigo" aria-label="Frigo">
              Frig.
            </ToggleButton>
            <ToggleButton value="Congel" aria-label="Congel">
              Cong.
            </ToggleButton>
            <ToggleButton value="Décongelé" aria-label="Décongelé">
              Décong.
            </ToggleButton>
          </ToggleButtonGroup>
        </div>

        <TextField id="category1" label={'Catégorie'} type="text" fullWidth size="small" InputLabelProps={{ shrink: true }} autoFocus={true}
          value={category1}
          onChange={(e) => changeCategory1(e.target.value)} />
        {categories1.length>0 ? (
          <div className="suggestions">
          {categories1.map((category1,index) => (
            <div className="suggestion" onClick={(e) => changeCategory1(category1)}>{category1}</div>
          ))}
          </div>
        ):null}

        <div className="mv-05">
          <div className="text-left">
            <div>Utilisation</div>
            <ToggleButtonGroup value={used} exclusive onChange={(event, newAlignment) => changeUsed(newAlignment)} aria-label="Utilisation">
              <ToggleButton value="" aria-label="Non">
                X
              </ToggleButton>
              <ToggleButton value="Consommé" aria-label="Consommé">
                Consommé
              </ToggleButton>
              <ToggleButton value="Jeté" aria-label="Jeté">
                Jeté
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          {used && used!='' ? (
          <TextField label="Date d'utilisation" type="date" size="small" InputLabelProps={{ shrink: true }} fullWidth 
            value={S_Date.formatDateForMaterial(dateUsedForMaterial)} 
            onChange={(e) => changeDateUsed(e.target.value)} />
          ) : null}
          
        </div>

      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">Annuler</Button>
        <Button onClick={(e) => onClickDelete()} color="primary">Supprimer</Button>
        <Button onClick={validate} color="primary">Valider</Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default DialogEditStock;
